import React, { FC } from 'react';

import { fontFamilies } from 'components/UI/Font';
import { mailTo, customerCareEmail } from 'helpers/emailAddresses';
import { faq, ordersAndShipping, returnsAndRefunds } from 'helpers/routes';

import { ChatActivator } from './ChatActivator';

export const HelpfulInformation: FC<{
  gridArea: string;
  localized: (url: string) => string;
}> = ({ gridArea, localized }) => (
  <div className="helpful-info-container">
    <p className="helpful-info-title">Helpful information</p>
    <ul>
      <li>
        <a href={localized(ordersAndShipping)}>Orders & Shipping</a>
      </li>
      <li>
        <a href={localized(returnsAndRefunds)}>Returns & Refunds</a>
      </li>
      <li>
        <a href={localized(faq)}>FAQ</a>
      </li>
    </ul>
    Questions? Contact us at <a href={mailTo(customerCareEmail)}>{customerCareEmail}</a> or{' '}
    <ChatActivator>click here</ChatActivator> to chat with us!
    <style jsx>{`
      .helpful-info-container {
        grid-area: ${gridArea};
        margin-top: 30px;
      }

      .helpful-info-title {
        font-family: ${fontFamilies.bold};
      }

      ul {
        list-style-type: disc;
        margin-bottom: 30px;
      }

      li {
        line-height: 20px;
        padding-left: 10px;
      }

      a {
        text-decoration: underline;
      }

      @media (min-width: 1024px) {
        .helpful-info-container {
          max-width: 360px;
        }
      }
    `}</style>
  </div>
);
